<div class="sg-notifications-panel">
  <div class="sg-notifications-panel-header sg-flex-row-wrap sg-justify-between sg-items-center sg-gap-20">
    <mat-slide-toggle color="primary" (change)="showOnlyReadChanged($event)"><span translate>Show only unread</span></mat-slide-toggle>
    <mat-form-field>
      <mat-select placeholder="Filter By" [(value)]="filterBy" (selectionChange)="filterByChanged($event)">
        <mat-option value="all">All</mat-option>
        <mat-option value="alerts">Alerts</mat-option>
        <mat-option value="messages">Messages</mat-option>
        <mat-option value="reports">Reports</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <mat-list class="sg-notifications-panel-body">
    <mat-divider></mat-divider>
    @for (item of [1, 2, 3, 4]; track $index) {
      <mat-list-item>
        <mat-icon mat-list-icon>email</mat-icon>
        <h4 mat-line>Mail Subject #{{ item }} daq3223c dsf 23 2rf dsf32 fsdf e</h4>
        <p mat-line>14 Mar, 2018</p>
      </mat-list-item>
      <mat-divider></mat-divider>
    }
  </mat-list>
</div>
